<template>
    <rkm-card>
        <strong>Gerenciador de certificado: </strong>
        <span v-if="isPkiInstalled">Instalado</span>
        <rkm-button
            v-else
            @click="redirectToInstallPage"
            color="primary"
        >
            Instalar
        </rkm-button>
    </rkm-card>
</template>

<script>
import { mapActions } from 'vuex'
import { webPki, error } from '@/mixins'

export default {
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        loadInstallation() {

            this.setLoading()

            this.init()
                .catch(error => this.isPkiInstalled && this.handleError(error))
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [webPki, error]
}
</script>